import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { applyStoredReferral } from "@/lib/referral";
import { gaEvent } from "@/lib/analytics";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { navigate("/auth"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setSession(data);
        if (data.is_new) gaEvent("sign_up", { method: "google" });
        await applyStoredReferral();
        navigate("/for-you");
      } catch {
        navigate("/auth");
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="min-h-screen grid place-items-center bg-pula-bg">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-pula-green mx-auto" />
        <p className="font-body text-pula-inksoft mt-3">Signing you in…</p>
      </div>
    </div>
  );
}
